import { AppComponent } from "./app.component";
import { AppModule } from "./app.module";
import { NgModule, LOCALE_ID } from "@angular/core";
import {
  ServerModule,
  ServerTransferStateModule
} from "@angular/platform-server";
import { ModuleMapLoaderModule } from "@nguniversal/module-map-ngfactory-loader";
import { BrowserModule } from "@angular/platform-browser";
import { NoopAnimationsModule } from "@angular/platform-browser/animations";
import { environment } from "../environments/environment";

@NgModule({
  imports: [
    BrowserModule.withServerTransition({ appId: "app-root" }),
    AppModule,
    ServerModule,
    NoopAnimationsModule,
    ModuleMapLoaderModule,
    ServerTransferStateModule
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: environment.locale
    }
  ],
  bootstrap: [AppComponent]
})
export class AppServerModule {}
